const paymentMethods = require('./paymentMethods');

module.exports = code => {
  var method = paymentMethods.find(p => p.code === code);
  return method && method.title;
};